<template>
  <div class="leave-sum" style="padding: 24px">
    <el-row class="query">
      <el-date-picker type="month" @change="query" v-model="monthDate" :clearable="false" placeholder="选择日期">
      </el-date-picker>

      <el-button @click.native="query" style="margin-left: 8px">查询</el-button>
    </el-row>

    <el-row class="total-info">
      <el-col :span="4">
        <el-card shadow="always" class="cnt-card">
          累计请假{{ cntInfo.nums }}人/{{ cntInfo.times }}次
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="always" class="cnt-card"> 累计请假{{ cntInfo.days }}天 </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="always" class="cnt-card">
          临时事假{{ cntInfo.specNums }}人/{{ cntInfo.specTimes }}次
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="always" class="cnt-card"> 累计超假{{ cntInfo.exceeds }}天 </el-card>
      </el-col>
      <el-col :span="8"> </el-col>
    </el-row>

    <el-table class="sum-table" :data="infos" @expand-change="view" max-height="580">
      <el-table-column sortable prop="carNo" label="班号" width="80"></el-table-column>
      <el-table-column prop="name" label="姓名" width="80"></el-table-column>
      <el-table-column sortable prop="times" label="已请假次数" min-width="120"></el-table-column>
      <el-table-column sortable prop="days" label="已请假天数" min-width="120"></el-table-column>
      <el-table-column sortable prop="exceeds" label="超假天数" min-width="120"></el-table-column>
      <el-table-column sortable prop="emergdays" label="临时假" min-width="100"></el-table-column>
      <el-table-column sortable prop="comdays" label="普通假" min-width="100"></el-table-column>
      <el-table-column label="查看详情" type="expand" width="100">
        <template slot-scope="scope">
          <div class="detail-row" v-for="(child, i) in scope.row.children" :key="i">
            <span class="detail-item detail-index">{{ i + 1 }}</span>
            <span class="detail-item">{{
              child.leaveCauseName +
              "-" +
              (child.confirmDate ? (child.realDays == 0 ? "已取消" : "已销假") : "请假中")
            }}</span>
            <span class="detail-item">{{
              child.sdate + "至" + (child.confirmDate ? child.confirmDate.substring(0, 10) : "")
            }}</span>
            <span class="detail-item">预计{{ child.days }}天</span>
            <span class="detail-item">实休{{ child.realDays }}天</span>
            <span class="detail-item">{{ child.confirmDate | dateFormat("hh:mm") }} 销假</span>
            <span class="detail-item detail-cause" :title="child.causeBz">{{ child.causeBz }}</span>
            <span class="detail-item">
              <template v-if="child.auditNormalDays">常规{{ child.auditNormalDays }}天</template>
              <template v-if="child.auditEmergencyDays">非常规{{ child.auditEmergencyDays }}天</template>
              <template v-if="child.auditAsworkingDays">工作{{ child.auditAsworkingDays }}天</template>
            </span>
            <span class="detail-item" v-html="child.attach"></span>
            <el-button class="detail-action" type="text" size="mini"
              @click="checkLeave(child, scope.row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="showPoper" title="修改请假审批" width="700px">
      <el-row class="leave-row">司机：{{ curLeave.carNo }}{{ curLeave.name }}</el-row>
      <el-row class="leave-row">请假日期：{{ curLeave.sdate }}</el-row>
      <el-row class="leave-row">请假事由：{{ curLeave.causeBz }}</el-row>
      <el-row class="leave-row">实休天数：{{ curLeave.realDays != null ? curLeave.realDays + "天" : "还未结束" }}</el-row>
      <el-row class="leave-row leave-days">
        <span>折算工作天数：<el-input v-model="audit.asworkingDays" size="mini"></el-input></span>
        <span>折算常规天数：<el-input v-model="audit.normalDays" size="mini"></el-input></span>
        <span>折算非常规天数：<el-input v-model="audit.emergencyDays" size="mini"></el-input></span>
      </el-row>
      <el-row class="btn-group" slot="footer">
        <el-button size="mini" @click="showPoper = false">取消</el-button>
        <el-button size="mini" type="primary" @click="applyLeave">保存</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { DateUtil, ParamUtil } from "@/util/index";
import { auditLeave } from "@/api";

export default {
  name: "LeaveSum",
  props: {
    team: {
      type: Number
    }
  },
  data() {
    return {
      monthDate: new Date(),
      cntInfo: { nums: 0, times: 0, days: 0, exceeds: 0, specNums: 0, specTimes: 0 },
      infos: [],
      curLeave: {},
      curParent: null,
      showPoper: false,
      audit: {}
    };
  },
  methods: {
    view(row) {
      if (!row.children || !row.children.length) {
        let param = {
          sdate: DateUtil.format(this.monthDate, "yyyy-MM-dd"),
          driverId: row.driver_id
        };
        this.$http
          .post("/admin/driver/leave/detail", ParamUtil.filterEmptyData(param))
          .then((res) => {
            let children = res.data || [];
            children.forEach((c) => {
              if (c.imgs) {
                let imgList = c.imgs.split(",");
                let hrefs = "";
                let i = 1;
                imgList.forEach((img) => {
                  hrefs += "<a href='" + img + "' target='_blank'>附件" + i++ + "</a>";
                  if (i <= imgList.length) {
                    hrefs += "&nbsp;&nbsp;";
                  }
                });
                c.attach = hrefs;
              } else {
                c.attach = "";
              }
            });
            row.children = children;
          });
      }
    },
    checkLeave(child, parent) {

      this.curParent = parent;
      this.curLeave = {
        ...child,
        carNo: parent.carNo,
        name: parent.name,
        sdate: child.sdate ? String(child.sdate).substring(0, 10) : ""
      };
      this.audit = {
        asworkingDays: child.auditAsworkingDays || 0,
        normalDays: child.auditNormalDays || 0,
        emergencyDays: child.auditEmergencyDays || 0
      };
      this.showPoper = true;
    },
    applyLeave() {
      const asworkingDays = Number(this.audit.asworkingDays) || 0;
      const normalDays = Number(this.audit.normalDays) || 0;
      const emergencyDays = Number(this.audit.emergencyDays) || 0;
      const auditDays = asworkingDays + normalDays + emergencyDays;
      if (this.curLeave.realDays != null && auditDays !== Number(this.curLeave.realDays)) {
        this.$message.error("审核天数与实际请假天数不符");
        return;
      }
      auditLeave({
        leaveId: this.curLeave.id,
        agree: true,
        asworkingDays,
        normalDays,
        emergencyDays,
        adminBz: "收车申请审核通过"
      }).then(() => {
        this.showPoper = false;
        this.curLeave = {};
        this.audit = {};
        if (this.curParent) {
          this.curParent.children = [];
          this.query();
        }
      });
    },
    query() {
      let param = {
        teamId: this.team ? this.team : null,
        month: this.monthDate.getMonth() + 1,
        year: this.monthDate.getFullYear()
      };
      this.$http.post("/admin/driver/leave/info", ParamUtil.filterEmptyData(param)).then((res) => {
        let infos = (res.data && res.data.infos) || [];
        infos.forEach((info) => {
          info.children = [];
        });
        this.infos = infos;
        if (res.data && res.data.cntInfo) {
          this.cntInfo = res.data.cntInfo;
        }
      });
    }
  }
};
</script>

<style scoped>
.total-info {
  margin: 12px 0;
}

.cnt-card {
  width: 240px;
  height: 48px;
  line-height: 28px;
  text-align: center;
}

.cnt-card>>>.el-card__body {
  padding: 10px;
}

.sum-table {
  width: 80%;
}

.detail-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  background-color: #f2f3f4;
  padding: 8px 12px;
  border-bottom: 1px solid #ebeef5;
  white-space: nowrap;
  font-size: 13px;
  line-height: 28px;
  overflow: hidden;
}

.detail-item {
  flex-shrink: 0;
}

.detail-index {
  width: 20px;
  text-align: center;
}

.detail-cause {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-action {
  flex-shrink: 0;
  margin-left: auto;
  padding-right: 24px;
}
</style>

<style lang="less">
.leave-sum {
  .leave-row {
    line-height: 32px;
  }

  .leave-row span {
    display: inline-block;
    margin-right: 16px;
  }

  .btn-group {
    text-align: right;
  }

  .leave-days {
    margin-top: 12px;

    .el-input {
      width: 80px;
    }
  }
}
</style>
